<div class=" mt-4">
  <section>
      <div class="row">
          <div class="col-md-10">
              <!-- <div class="float-right">
                  <button class="btn dash-btns mr-3" [routerLink]="['/ecomsolutions/Paynow/new']">New Pay Now</button>
                  <button class="btn dash-btns mr-3" [routerLink]="['/ecomsolutions/Paynow/manage']">Manage Pay
                      Now</button>
                  <button class="btn dash-btns" [routerLink]="['/reports/transactions/summary']">Reports</button>

              </div> -->
          </div>
      </div>

  </section>
  <section class="mt-3">
      <div class="">
          <div class="row">
              <div class="col-md-8 offset-md-2">
                  <div class="card-1">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="text-center mb-5">
                                  <img src="assets/img/new/view-trans.svg" />
                              </div>
                              <div class="text-center">
                                  <a class="view-h gary-t">View BulkUpload File</a>

                              </div>

                              <div class="pt-3">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <div class=" ">
                                        <!-- <div class="row mb-3">

                                            <div class="col-4 p-0"> <label>PayOut Bulk FileId</label> </div>

                                            <div class="col-7 p-0 view-text robot"> {{rows.PayOutBulkFileId}}
                                                                             </div>
                                        </div> -->
                                        <div class="row mb-3">

                                            <div class="col-4 p-0"> <label>FileName</label> </div>

                                            <div class="col-7 p-0 view-text robot"> {{rows.FileName}}</div>
                                        </div>
                                        <div class="row mb-3">

                                            <div class="col-4 p-0"> <label>Total Amount</label>  </div>

                                            <div class="col-7 p-0 view-text robot"> {{rows.TotalAmount | currency:"₹"}}</div>
                                        </div>
                                        <!-- <div class="row mb-3">

                                            <div class="col-4 p-0"> <label> Success Amount</label></div>

                                            <div class="col-7 p-0 view-text robot"> {{rows.SuccessAmount}}</div>
                                        </div> -->

                                        <!-- <div class="row mb-3">

                                            <div class="col-4 p-0"> <label>Failed Amount </label>  </div>

                                            <div class="col-7 p-0 view-text"> {{rows.FailedAmount}}</div>
                                        </div> -->
                                        <div class="row mb-3">

                                            <div class="col-4 p-0"><label> Total Record Count </label>  </div>

                                            <div class="col-7 p-0 view-text robot"> {{rows.TotalRecordCount}}</div>
                                        </div>
                                        <!-- <div class="row mb-3">

                                            <div class="col-4 p-0"> <label> Success Record Count </label>  </div>

                                            <div class="col-7 p-0 view-text"> {{rows.SuccessRecordCount}}</div>
                                        </div>
                                        <div class="row mb-3">

                                            <div class="col-4 p-0"> <label> Failed Record Count</label>  </div>

                                            <div class="col-7 p-0 view-text robot">   {{rows.FailedRecordCount }}</div>
                                        </div> -->
                                        <div class="row mb-3">

                                            <div class="col-4 p-0"> <label>Status</label>  </div>

                                            <div class="col-7 p-0 view-text text-warning" *ngIf="rows.Status==0">
                                              Inprogress
                                             </div>
                                             <div class="col-7 p-0 view-text text-warning" *ngIf="rows.Status ==1">
                                              Ready For Approval
                                              </div>
                                              <div class="col-7 p-0 view-text text-primary" *ngIf="rows.Status ==2">
                                                Processing
                                                </div>
                                                <div class="col-7 p-0 view-text text-success" *ngIf="rows.Status ==3">
                                                  Completed
                                                  </div>

                                                  <div class="col-7 p-0 view-text text-danger" *ngIf="rows.Status ==4">
                                                   Cancel
                                                    </div>

                                        </div>
                                        <!-- <div class="row mb-3">

                                          <div class="col-4 p-0"> <label>Approval Status</label>  </div>

                                          <div class="col-7 p-0 view-text robot"> {{rows.ApprovalStatus}}</div>
                                      </div>
                                      <div class="row mb-3">

                                        <div class="col-4 p-0"> <label>ApprovedBy</label>  </div>

                                        <div class="col-7 p-0 view-text robot"> {{rows.ApprovedBy}}</div>
                                    </div> -->
                                    <div class="row mb-3">

                                      <div class="col-4 p-0"> <label>UploadDateTime</label>  </div>

                                      <div class="col-7 p-0 view-text robot"> {{rows.UploadDateTime | date:'d/M/yy, h:mm a'}}</div>
                                  </div>

                                        <div class="row m-1 text-right">


                                        </div>
                                    </div>
                                    </div>
                                  </div>
                              </div>

                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12  ">

              <div class="card-1">
                <div class="row mx-0">
                  <div class="col-md-12">
                      <h4 class="font-weight-bold d-inline">View BulkUpload File Details</h4>
                      <div class="dropdown d-inline float-right mb-3">
                        <button class="btn dash-btns mr-3" type="button" data-toggle="dropdown">Download  &nbsp;<i class="fas fa-caret-down"></i>
                        </button>
                        <ul class="dropdown-menu text-center">
                          <li><a  id="btnExportBatch" (click)="readAndExportToExcelData()" >Excel</a></li>

                        </ul>
                      </div>
                  </div>



              </div>





                <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
                [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="row">
                <ngx-datatable-column name="Action">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <a class=" edit" [routerLink]="['/PayOut/ViewPayOutBulkUploaddetails',{Id: row.Id}]"
                     data-toggle="tooltip"
                      data-placement="top" title="View">
                      <img src="./assets/ViewDetails.svg">
                    </a>


                  </ng-template>
                </ngx-datatable-column>

                <!-- [width]="200" -->
                <!-- <ngx-datatable-column name="PayOut Bulk FileId"  [width]="200">
                  <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayOutBulkFileId}}
                  </ng-template>
                </ngx-datatable-column> -->

                <ngx-datatable-column name="Payout Customer keyId">
                  <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayoutCustomerkeyId}} </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="PayOut Beneficiary KeyId">
                  <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayOutBeneficiaryKeyId}} </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Payment Type">
                  <ng-template let-row="row" ngx-datatable-cell-template> <div class="robot font400">{{row.PaymentType}}</div>
                  </ng-template>
                </ngx-datatable-column>
                  <ngx-datatable-column name="Note">
                    <ng-template let-row="row" ngx-datatable-cell-template> <div class="robot font400">{{row.notes}}</div>
                    </ng-template>
                  </ngx-datatable-column>
                    <!-- <ngx-datatable-column name="PayOut Transaction Id">
                      <ng-template let-row="row" ngx-datatable-cell-template> <div class="robot font400">{{row.PayOutTransactionId}}</div>
                      </ng-template>

                </ngx-datatable-column> -->
                <ngx-datatable-column name="Status">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="status-warning-btn" *ngIf="row.Status==0">
                      Pending
                    </span>
                    <span class="status-approved-btn" *ngIf="row.Status==1">
                      Approved
                    </span>
                    <span class="status-danger-btn" *ngIf="row.Status==2">
                      Failed
                    </span>
                    <span class="status-approved-btn" *ngIf="row.Status==3">
                      Completed
                    </span>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Datetime">
                  <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.LastUpdateDatetime  | date:'d/M/yy, h:mm a'}}</div></ng-template>
                </ngx-datatable-column>





              </ngx-datatable>
              </div>
            </div>
          </div>
      </div>
  </section>
</div>






